/** Shared contact details and navigation for the public marketing site. */

export const SUPPORT_PHONE = { display: "1 (844) 435-4795", href: "tel:18444354795" };
export const SUPPORT_EMAIL = "Support@flipiq.com";

export interface SiteLink {
  label: string;
  href: string;
  description?: string;
  /** Opens in a new tab (external products) */
  external?: boolean;
}

export interface SiteNavItem {
  label: string;
  href?: string;
  /** Renders a dropdown instead of a link */
  children?: SiteLink[];
  /** Highlight as active for these path prefixes */
  match?: string[];
}

/** Every FlipIQ product a visitor can sign in to */
export const PLATFORM_LOGINS: SiteLink[] = [
  { label: "Marketplace", href: "/signin", description: "Off-market deals and buyers" },
  { label: "Platform", href: "https://platform.flipiq.com/login", description: "Acquisition and disposition", external: true },
  { label: "Agent/Investor Reports", href: "https://data.flipiq.com/", description: "Track-record data", external: true },
  { label: "Coaching", href: "https://seegoal.replit.app/", description: "AI-driven coaching", external: true },
  { label: "Probidder", href: "https://probidder.flipiq.com/login", description: "Scope of work and construction", external: true },
  { label: "AI Scripts Coaching", href: "https://flipiq.vercel.app/", description: "Outreach script training", external: true },
  { label: "Compliance", href: "https://compliance-estate-td2535.replit.app/", description: "Transaction compliance", external: true },
  { label: "BuyeriQ", href: "https://anchorloans-buyeriq.vercel.app/", description: "Buyer matching", external: true },
];

export const AUDIENCE_LINKS: SiteLink[] = [
  { label: "Buyers", href: "/info/buyer", description: "Validated off-market deals" },
  { label: "Sellers", href: "/info/seller", description: "Competing cash offers" },
  { label: "Agents", href: "/info/agent", description: "Double-end your listings" },
  { label: "Wholesalers", href: "/info/wholesaler", description: "Monetize your buyers list" },
];

export const COMPANY_LINKS: SiteLink[] = [
  { label: "About FlipIQ", href: "/about" },
  { label: "Leadership", href: "/our-leadership" },
  { label: "Our difference", href: "/info/our-difference" },
  { label: "FAQs", href: "/info/faqs" },
];

export const LEGAL_LINKS: SiteLink[] = [
  { label: "Terms of Service", href: "/terms-of-service" },
  { label: "Privacy Policy", href: "/privacy-policy" },
];

export const PLATFORM_DISCLAIMER =
  "Our Site is all about connecting sellers, buyers and intermediaries. We do not buy real estate and we do not act as a real estate agent or broker. Rather, the FlipIQ Platform provides an online environment in which our users can connect with others and obtain information about available real estate properties. Through our Platform, we help facilitate our users' independently negotiated transactions by providing term sheets and contracts that users may elect to use to sell or purchase single family real property assets. We do not provide legal advice or guarantee any information provided by our members or their representations.";

export const INQUIRY_TYPES = [
  { value: "selling", label: "Selling" },
  { value: "buying", label: "Buying" },
  { value: "marketplace", label: "Marketplace" },
  { value: "platform", label: "Platform" },
  { value: "investor-agent-reports", label: "Investor and agent reports" },
  { value: "probidder", label: "Probidder" },
  { value: "coaching", label: "Coaching" },
  { value: "script-training", label: "Script training" },
  { value: "compliance", label: "Compliance" },
  { value: "buyeriq", label: "BuyeriQ" },
];

/** Main navigation for the public marketing pages */
export const MARKETING_NAV: SiteNavItem[] = [
  { label: "Solutions", children: AUDIENCE_LINKS, match: ["/info/buyer", "/info/seller", "/info/agent", "/info/wholesaler"] },
  { label: "Tools for pros", href: "/tools-for-pros" },
  {
    label: "Company",
    children: [
      { label: "About FlipIQ", href: "/about", description: "Our mission and story" },
      { label: "Leadership", href: "/our-leadership", description: "The team and advisors" },
      { label: "Our difference", href: "/info/our-difference", description: "Why our buyer network is different" },
    ],
    match: ["/about", "/our-leadership", "/info/our-difference"],
  },
  { label: "FAQs", href: "/info/faqs" },
];
